import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import { searchBenefits, resetPinBenefits } from 'redux/actions';
import './benefitsMap.scss';

//components
import Benefit   from 'containers/shared/benefit/benefit';
import Map from "../../../components/services/google/map";
import Markers from '../../shared/google/markers/markers';
import InfoWindow from './infoWindowSlider/infoWindowSlider';
import Loader from '../../../components/common/loader';

//assets
 //import map_pin from 'assets/icons/map-pin.svg';
import map_pin from 'assets/icons/map-pin.png';
import {cleanUpObject} from "../../../app/functions";


class BenefitsMap extends Component{

    constructor(props){
        super(props);

        this.state ={
            infoWindow:false,
            mapLoaded:false,
            clusters: false,
            current:1,
        };

        this.setMarkersData = this.setMarkersData.bind(this);
        this.handleMapOnLoaded = this.handleMapOnLoaded.bind(this);
        this.handleMapUnLoad = this.handleMapUnLoad.bind(this);
        this.handlePinOnClick = this.handlePinOnClick.bind(this);
        this.handleMapOnClick = this.handleMapOnClick.bind(this);
        this.clustersScriptOnLoad = this.clustersScriptOnLoad.bind(this);
        this.getPinBenefits = this.getPinBenefits.bind(this);
        this.arrowOnClick = this.arrowOnClick.bind(this);
    }

    componentDidUpdate(prevProps){
        if (!this.isEquivalent(prevProps.Filters, this.props.Filters)){
            this.forceUpdate();
        }
    }

    isEquivalent(a, b) {
        let aProps = Object.getOwnPropertyNames(a);
        let bProps = Object.getOwnPropertyNames(b);

        if (aProps.length !== bProps.length) {
            return false;
        }

        for (let i = 0; i < aProps.length; i++) {
            let propName = aProps[i];

            if (a[propName].id !== b[propName].id) {
                return false;
            }
        }

        return true;
    }


    handlePinOnClick(benefits){
        this.props.resetPinBenefits();


        const filters = this.props.Filters;

        let payload = {
            latitude: benefits.getPosition().lat(),
            longitude: benefits.getPosition().lng(),
            radius: 0.001,
            limit: 99999
        };

        for (let key in filters){
            if (filters[key].id !== -1) {
                payload[key] = filters[key].id
            }
        }

        this.props.searchBenefits(payload);
        this.setState({infoWindow: true});
    }

    handleMapOnClick(){
        this.props.resetPinBenefits();
        this.setState({infoWindow:false, current:1});
    }

    setMarkersData(){
        const records = [...this.props.filters?.records];
        let markers = [];



        if(records) {
            records.forEach(curr => {
                // curr.image_url = getMediaPath((curr.hot_benefit ? this.props.iconTypes[curr.type].greenImagePath : this.props.iconTypes[curr.type].imagePath));
                curr.supplierLocations.forEach(branch => {
                    markers.push(
                        {
                            benefit:curr,
                            location: new window.google.maps.LatLng(branch.lat, branch.lon),
                            mapPin: {url: map_pin, scaleSize: new window.google.maps.Size(20, 27)},
                            handlePinOnClick: this.handlePinOnClick,
                        });
                });
            });
        }

        return markers;
    }

    handleMapOnLoaded(){
        this.setState({mapLoaded:true})
    }

    handleMapUnLoad() {
        this.setState({mapLoaded:false})
    }

    clustersScriptOnLoad(){
        this.setState({clusters: true});
    }

    getPinBenefits(){
        const pinBenefits = this.props.pinBenefits;
        let res = [];

        if(pinBenefits){
            pinBenefits.forEach((item,index) =>{
                res.push(<Benefit key={index} data={item}/>)
            })
        }

        return res;
    }

    arrowOnClick(current){
        this.setState({current:current + 1})
    }


    render(){
        const filters = this.props.filters;
        return(
            <section className='benefitsMap'>
                {filters &&
                <Fragment>
                    <div className='map-wrapper'>
                        <Map apiKey={window.googleMapsApiKey}
                             id={'benefits-map'}
                             onMapLoad={this.handleMapOnLoaded}
                             onClusterLoad={this.clustersScriptOnLoad}
                             onMapUnload={this.handleMapUnLoad}
                             options={{
                                 zoom: 15,
                                 center: {lat: 32.062510, lng: 34.778832},
                                 zoomControl: true,
                                 mapTypeControl: false,
                                 scaleControl: false,
                                 streetViewControl: false,
                                 rotateControl: false,
                                 fullscreenControl: false,
                                 clickableIcons: false
                             }
                             }/>
                        <InfoWindow active={this.state.infoWindow}
                                    className='info-benefits'
                                    current={this.state.current}
                                    arrowOnClick={this.arrowOnClick}>
                            {this.getPinBenefits()}
                        </InfoWindow>
                        {this.state.mapLoaded && this.state.clusters &&
                        <Markers mapID={'benefits-map'}
                                 data={this.setMarkersData()}
                                 handleMapOnClick={this.handleMapOnClick}
                                 constantlyUpdate={false}
                        />
                        }
                    </div>
                </Fragment>
                }
                {!filters &&
                    <Loader/>
                }
            </section>
        )
    }
}


//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        device: store.state.deviceState,
        text: store.config.Translations,
        Benefits: store.data.FilteredBenefits,
        requesting: store.state.requesting,
        defaultGeo: store.config.DefaultGeo,
        iconTypes: cleanUpObject(store.config.IconTypes),
        pinBenefits: store.data.PinBenefits,
        Filters: store.state.benefitSearchFilters,
        filters: store.data.Filters,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        searchBenefits: (payload) => dispatch(searchBenefits(payload)),
        resetPinBenefits: ()=> dispatch(resetPinBenefits()),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(BenefitsMap);
